import { render, staticRenderFns } from "./JournalColumnEditor.vue?vue&type=template&id=4e772d88&scoped=true&"
import script from "./JournalColumnEditor.vue?vue&type=script&lang=js&"
export * from "./JournalColumnEditor.vue?vue&type=script&lang=js&"
import style0 from "./JournalColumnEditor.vue?vue&type=style&index=0&id=4e772d88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e772d88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
